export const FETCH_JORNADA = 'FETCH_JORNADA';
export const FETCH_JORNADA_SUCCESS = 'FETCH_JORNADA_SUCCESS';

export const SAVE_JORNADA = 'SAVE_JORNADA';
export const SAVE_JORNADA_SUCCESS = 'SAVE_JORNADA_SUCCESS';

export const CLEAR_SELECTED_JORNADA = 'CLEAR_SELECTED_JORNADA';
export const CLEAR_JORNADA = 'CLEAR_JORNADA';

export const EXPORT_JORNADAS = 'EXPORT_JORNADAS';
export const JORNADA_DELETE = 'JORNADA_DELETE';
export const JORNADA_DELETE_SUCCESS = 'JORNADA_DELETE_SUCCESS';
export const JORNADA_DOWNLOAD = 'JORNADA_DOWNLOAD';
